import createIcon from '../../createIcon';

/**
 * @component @name VpnKeyOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuODMgMTcuMjg5NkgyMVYxMy4yODk2SDIzVjkuMjg5NjFIMTIuODNMMjAuODMgMTcuMjg5NlpNMTkuNzggMjEuODk5NkwyMS4xOSAyMC40ODk2TDIuODEgMi4wOTk2MUwxLjM5IDMuNTA5NjFMMy45OCA2LjA5OTYxQzIuMiA3LjEzOTYxIDEgOS4wNzk2MSAxIDExLjI4OTZDMSAxNC41OTk2IDMuNjkgMTcuMjg5NiA3IDE3LjI4OTZDOS4yMSAxNy4yODk2IDExLjE1IDE2LjA4OTYgMTIuMTggMTQuMjk5NkwxOS43OCAyMS44OTk2Wk04Ljk5IDExLjEwOTZDOSAxMS4xNjk2IDkgMTEuMjI5NiA5IDExLjI4OTZDOSAxMi4zODk2IDguMSAxMy4yODk2IDcgMTMuMjg5NkM1LjkgMTMuMjg5NiA1IDEyLjM4OTYgNSAxMS4yODk2QzUgMTAuMTg5NiA1LjkgOS4yODk2MSA3IDkuMjg5NjFDNy4wNiA5LjI4OTYxIDcuMTIgOS4yODk2MSA3LjE4IDkuMjk5NjFMOC45OSAxMS4xMDk2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VpnKeyOff = createIcon('VpnKeyOff', [
  [
    'path',
    {
      d: 'M20.83 17.2896H21V13.2896H23V9.28961H12.83L20.83 17.2896ZM19.78 21.8996L21.19 20.4896L2.81 2.09961L1.39 3.50961L3.98 6.09961C2.2 7.13961 1 9.07961 1 11.2896C1 14.5996 3.69 17.2896 7 17.2896C9.21 17.2896 11.15 16.0896 12.18 14.2996L19.78 21.8996ZM8.99 11.1096C9 11.1696 9 11.2296 9 11.2896C9 12.3896 8.1 13.2896 7 13.2896C5.9 13.2896 5 12.3896 5 11.2896C5 10.1896 5.9 9.28961 7 9.28961C7.06 9.28961 7.12 9.28961 7.18 9.29961L8.99 11.1096Z',
      key: '1x57es',
    },
  ],
]);

export default VpnKeyOff;
